import { render } from "./Restock.vue?vue&type=template&id=15f7920c"
import script from "./Restock.vue?vue&type=script&lang=js"
export * from "./Restock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__